import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { BrokerItem } from "./source-name-table-dsiplay.model";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";

@Component({
  selector: "app-source-name-table-display",
  templateUrl: "./source-name-table-display.component.html",
  styleUrls: ["./source-name-table-display.component.scss"],
  host: { class: "source-name-table-display-component" },
  encapsulation: ViewEncapsulation.None,
})
export class SourceNameTableDisplayComponent implements OnChanges {
  @Input() brokerItem: BrokerItem;
  @Input() showCurrentViewInfo: boolean;
  @Input() ccState?: boolean;
  @Input() currentState: boolean;
  @Output() nameClicked: EventEmitter<{
    id: number;
    selected: boolean;
  }> = new EventEmitter();

  shouldCPlusShow = false;
  shouldCCShow = false;

  assets = window.assetUrl;

  ngOnChanges() {
    //if ccState is undefined [that means toplevel cc state is not provided]
    //in that case use only broker level cc state to Determine whether cc icon should show
    //if ccState is not undefined [that means topleel cc state is provided as input]
    //in this case use top-level as well as broker level cc state
    this.shouldCCShow = this.brokerItem.selected_cc;
    this.shouldCCShow =
      this.ccState !== undefined
        ? this.ccState && this.shouldCCShow
        : this.shouldCCShow;

    //this logic is when all three icons (cc, c+, ex) are visible
    //hides the c+ icon
    this.shouldCPlusShow = !(this.shouldCCShow && this.brokerItem.excluded);
  }
  // icons
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([infoCircle]);
  }
  onClickBrokerName() {
    const { sourceid } = this.brokerItem;
    this.nameClicked.emit({ id: sourceid, selected: !this.currentState });
  }
}
